<kendo-dialog title="{{'_General_Notification_Groups_Text_' | translate }}" [minWidth]="300" [width]="500" (close)="close()">
  <kendo-dialog-messages closeTitle="{{'_General_Button_Close_Text_' | translate }}"></kendo-dialog-messages>
  <div class="d-flex justify-content-center  cc-action-panel row">

    <div class="row cc-filters">
      <div class="cc-search">
        <input placeholder="{{'_General_Search_Text_' | translate }}" class="form-control" [(ngModel)]="searchText" (ngModelChange)="onChangeSearchText()" (keydown.enter)="onFilterTextEnterKeyPress()" />
        <button [ngClass]="{'show-btn': showClearButton}" (click)="onSeachClearButtonClick()"
                class="cc-close-btn">
          <span class="fas fa-times"></span>
        </button>
        <button (click)="onSearchButtonClick()" class="cc-search-btn"><span class="fas fa-search"></span></button>
      </div>
    </div>
  </div>
  <div class="table-wrapper">
    <table class="table table-striped table-borderless">
      <tbody>
        <tr *ngFor="let item of filteredList">
          <td>{{item}}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <kendo-dialog-actions class="cc-btn-panel" class="cc-btn-panel">
    <button class="btn btn-primary" primary="true" (click)="close()">{{'_General_Button_Close_Text_' | translate }}</button>
  </kendo-dialog-actions>
</kendo-dialog>
